export const environment = {
  production: true,
  backEndUrl: 'https://admin.test.myevents.costa.it/api',
  domain: 'test.myevents.costa.it',
  portaleFrontendUrl: 'https://test.myevents.costa.it',
  constantMaxReservationsPerEvent: 1,
  firebaseConfig: {
    apiKey: "AIzaSyAOCML7xeetzkH6FBHtSjZEqdH6Wg9dIQo",
    authDomain: "goreply-costa-wrt-stage-401707.firebaseapp.com",
    projectId: "goreply-costa-wrt-stage-401707",
    storageBucket: "goreply-costa-wrt-stage-401707.firebasestorage.app",
    messagingSenderId: "599928067438",
    appId: "1:599928067438:web:0477681d8fa528f1e19d7f"
  },
  firebaseProvider : 'oidc.auth2-wrt-stage'
};
